module.exports = __webpack_public_path__ + "img/bioNO.fb9fb5b0.png";